import { AbstractsService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const abstractQueryKey = (id: string) => {
  return ["abstract", id] as const;
};

function useAbstract(id: string) {
  return useQuery({
    queryKey: abstractQueryKey(id),
    queryFn: () => AbstractsService.getAbstractById({ id }),
  });
}

export { abstractQueryKey, useAbstract };
